<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="异常剔除记录"
      width="80%"
      top="6vh"
      append-to-body>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="sd/salesRevenueReport/excludeLog">
      <div slot="toolbar">
        <el-button type="primary" size="mini" :loading="exportLoading" @click="exportData">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="发货单号">
            <el-input v-model.trim="filter.deliveryNo" clearable/>
          </vm-search>
          <vm-search label="开始日期">
            <el-date-picker v-model="filter.beginTime" value-format="yyyy-MM-dd" type="date" style="width: 140px"/>
          </vm-search>
          <vm-search label="结束日期">
            <el-date-picker v-model="filter.endTime" value-format="yyyy-MM-dd" type="date" style="width: 140px"/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="deliveryNo" align="center" label="发货单号" min-width="160"/>
      <el-table-column prop="reason" align="center" label="剔除原因" min-width="160"/>
      <el-table-column prop="createBy" align="center" label="操作人" width="110"/>
      <el-table-column prop="createTime" align="center" label="操作时间" width="160"/>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="remove(scope.row)">撤销</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "ExcludeLogDialog",
    components: {VmTable, VmSearch},
    data() {
      return {
        dialogVisible: false,
        exportLoading: false,
        filter: {
          deliveryNo: "",
          beginTime: "",
          endTime: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      remove(row) {
        this.$confirm("确定撤销该剔除记录吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .post("basic", "sd/salesRevenueReport/deleteExclude", null, {pkid: row.pkid})
            .then(resp => {
              if (resp && resp.success === false) {
                return this.$message.error(resp.message || "撤销失败");
              }
              this.$message.success("撤销成功");
              this.getList(-1);
            });
        }).catch(() => {});
      },
      exportData() {
        this.exportLoading = true;
        this.$http
          .postForFile("basic", "sd/salesRevenueReport/exportExcludeLog", this.filter)
          .then(resp => {
            this.exportLoading = false;
            let blob = new Blob([resp.data]);
            let fileName = decodeURI(resp.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
